module.exports = __webpack_public_path__ + "img/right-leg_hover.abf9673e.png";